module.exports = __webpack_public_path__ + "img/0e5075718530278abdbbadfb956057a7.svg";